import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'admin-lte/dist/css/adminlte.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { i18nBaslat } from './i18n/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

i18nBaslat().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// PWA — Service Worker devre dışı
serviceWorkerRegistration.unregister();